// Base URL for your application - use localhost for development
const BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:3000'
  : (process.env.REACT_APP_BASE_URL || 'https://demo.plutoo.co.uk');

// Authentication action URLs - custom URLs for better handling
const AUTH_URLS = {
  VERIFY_EMAIL: `${BASE_URL}/auth-action-handler?mode=verifyEmail&continueUrl=${encodeURIComponent(BASE_URL + '/dashboard')}`,
  RESET_PASSWORD: `${BASE_URL}/auth-action-handler?mode=resetPassword&continueUrl=${encodeURIComponent(BASE_URL + '/login')}`,
  CONFIRM_EMAIL_CHANGE: `${BASE_URL}/auth-action-handler?mode=confirmEmailChange&continueUrl=${encodeURIComponent(BASE_URL + '/dashboard')}`
};

// Configuration for Firebase Authentication action URLs using custom URLs
export const getActionCodeSettings = (actionType) => ({
  url: AUTH_URLS[actionType],
  handleCodeInApp: true,
  iOS: {
    bundleId: 'com.plutoo.app'
  },
  android: {
    packageName: 'com.plutoo.app',
    installApp: true,
    minimumVersion: '12'
  },
  dynamicLinkDomain: process.env.REACT_APP_FIREBASE_DYNAMIC_LINK_DOMAIN
});

export const AUTH_ACTIONS = {
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD',
  CONFIRM_EMAIL_CHANGE: 'CONFIRM_EMAIL_CHANGE'
};
